import React from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import data from '../../../data/HomeServiceData.json'

export default function HomeService() {
  return (
    <Container>
      <Row className="justify-content-center home-service-row">
        <Col className='home-service-col' > <h2> Our Services </h2> </Col>
      </Row>
      <Row>
        <Col> <h3 className="home-service-col-one"> We Are The Leader Of Security Solutions </h3> </Col>
      </Row>
      <Row>
        {
          data.map((d) => (
            <Col xl={4} >
              <Card className='home-service-col-two'>
                <Link className='service_link' to={d.link}>
                  <img className="home-service-img" src={d.image} alt="Loading.." />
                  <h2 className='home-service-title' > {d.title} </h2>
                  <h3 className='home-service-text' > {d.text} </h3>
                </Link>
              </Card>
            </Col>
          ))
        }
      </Row>
    </Container>
  )
}
